import React from 'react';

import { useConvertorCrossRatesData } from 'hooks';

import AllRatesTableContainer from 'containers/AllRatesTableContainer';
import AllBanksTableContainer from 'containers/AllBanksTableContainer';
import CurrencyConverterContainer from 'containers/CurrencyConverterContainer';
import CurrencyExchangeTable from 'components/CurrencyExchangeTable';
import CrossRates from 'components/CrossRates';
import LinksBlock from 'components/LinksBlock';
import LandingLinksBlock from 'components/LandingLinksBlock';
import RatesDynamic from 'components/RatesDynamic';
import Banner from 'components/Banner';
import ContentBannerSection from 'components/ContentBannerSection';
import PageContent from 'components/PageContent';

const ConvertorLandingPageContent = () => {
  useConvertorCrossRatesData();

  return (
    <PageContent>
      <CurrencyConverterContainer />

      <ContentBannerSection hideOnDesktop>
        <Banner id="rp-react-banner-content-2-a-l" slot="bn-slot-content-2-a" />
      </ContentBannerSection>

      <LandingLinksBlock />

      <ContentBannerSection>
        <Banner id="rp-react-banner-content-2-l" slot="bn-slot-content-2" />
      </ContentBannerSection>

      <RatesDynamic />

      <ContentBannerSection>
        <Banner id="rp-react-banner-content-1-a-l" slot="bn-slot-content-1-a" />
      </ContentBannerSection>

      <AllRatesTableContainer />

      <AllBanksTableContainer />

      <CurrencyExchangeTable />

      <CrossRates />

      <LinksBlock />
    </PageContent>
  );
};

export default ConvertorLandingPageContent;
